import { FormattedDate, FormattedMessage, useIntl } from 'react-intl';
import { intlFormatCurrency } from '@iwIntlProvider/FormattedCurrency';
import styles from './xsellTitle.module.css';
import Fetching from '../../../../ui/fetching/fetching';
import IwMedia from '../../../../../iwMedia/IwMedia';
import { Icon } from '@iwoca/orion';
import messages from './xsellTitle.messages';

export const XSellTitle = ({
    expiryDate,
    maxCashAmount
}: {
    expiryDate?: string;
    maxCashAmount: number;
}) => {
    const intl = useIntl();

    return (
        <div className={styles.header}>
            <h1 className={styles.title}>
                <FormattedMessage
                    {...messages.title}
                    values={{
                        amount: (
                            <span className={styles.amount}>
                                {intlFormatCurrency({
                                    intl,
                                    value: maxCashAmount || 0
                                })}
                            </span>
                        )
                    }}
                />
            </h1>
            <h2 className={styles.subTitle}>
                <FormattedMessage
                    {...messages.expiryDate}
                    values={{
                        date: (
                            <Fetching isFetching={!expiryDate}>
                                <FormattedDate
                                    value={
                                        expiryDate
                                            ? new Date(expiryDate)
                                            : new Date()
                                    }
                                    day="2-digit"
                                    month="long"
                                    year="numeric"
                                />
                            </Fetching>
                        )
                    }}
                />
            </h2>
            <h2 className={styles.subTitle}>
                <FormattedMessage {...messages.subTitle} />
            </h2>
            <IwMedia from="medium">
                <ul className={styles.benefitPoints}>
                    <li>
                        <Icon icon="userFilled" />
                        <FormattedMessage {...messages.subheaderOne} />
                    </li>
                    <li>
                        <Icon icon="rocket" />
                        <FormattedMessage {...messages.subheaderTwo} />
                    </li>
                    <li>
                        <Icon icon="creditCardFilled" />
                        <FormattedMessage {...messages.subheaderThree} />
                    </li>
                </ul>
            </IwMedia>
        </div>
    );
};
